
import './App.css';
import Age from './Components/Age';

function App() {
  return (
    <div className="App">
      < Age />
    </div>
  );
}

export default App;
